import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import config from "../../Config";

const PrintConcessionStudents = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(false);
  const [students, setStudents] = useState([]);
  const [rule, setRule] = useState(null);

  const params = useParams();
  const ruleId = params.id;

  useEffect(() => {
    document.title = "Concession Students Report";
    setLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      Concession_Rule_ID: ruleId,
    };

    axios({
      method: "post",
      url: config.base_url + "Concession/GetConcessionStudentsReport",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          setStudents(response.data.ListofRecords || []);
          setRule(response.data.Rule || null);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [AccessKey, UserID, MemberType, ruleId]);

  const renderRows = () => {
    if (students.length === 0) {
      return (
        <tr>
          <td colSpan="7">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }

    return students.map((item, index) => (
      <tr key={index}>
        <td>{item.Serial_No}</td>
        <td>{item.Registration_No}</td>
        <td>{item.Student_Name}</td>
        <td>{item.Father_Name}</td>
        <td>{item.FamilyNo || "-"}</td>
        <td>{item.ClassName}</td>
        <td>{item.SectionName}</td>
      </tr>
    ));
  };

  const ruleTitle = rule
    ? `Concession Students: ${rule.Concession_Rule_Name}`
    : "Concession Students Report";

  return (
    <>
      <Page orientation="potrait" size="a4">
        <table className="table table-sm table-bordered table-print">
          <thead>
            <tr>
              <td colSpan="7">
                <PrintHeader title={ruleTitle} />
              </td>
            </tr>
            {rule && (
              <tr>
                <td colSpan="7">
                  <div className="d-flex justify-content-between">
                    <div>
                      <strong>Rule Code:</strong> {rule.Concession_Rule_Code}
                    </div>
                    <div>
                      <strong>Mode:</strong> {rule.ConcessionMode}
                    </div>
                  </div>
                </td>
              </tr>
            )}
          </thead>
          <tbody>
            <tr>
              <th>Sr#</th>
              <th>Reg No</th>
              <th>Student Name</th>
              <th>Father Name</th>
              <th>Family No</th>
              <th>Class</th>
              <th>Section</th>
            </tr>
            {loading ? (
              <tr>
                <td className="text-center" colSpan="7">
                  <Spinner animation="border" role="status"></Spinner>
                </td>
              </tr>
            ) : (
              <>{renderRows()}</>
            )}
          </tbody>
        </table>
      </Page>
    </>
  );
};

export default PrintConcessionStudents;
